import {
  ILocalizedTestElement,
  ITestGroupHeader,
  ResolvedLocalizedContent,
} from "@/modules/assessments/types/test.interface";
import { QuestionTypes } from "@/shared/components/candidate/scenes/TestElement/TestElement";

// Text elements carry their content in payload.body; every other type uses payload.question.
// Both arrive from the BE as ResolvedLocalizedContent envelopes; a missing/null value renders empty.
export function getResolvedElementText(element: ILocalizedTestElement): string | [string, string] {
  const { type } = element.config;
  const { body, question } = element.config.payload;

  return (type === QuestionTypes.Text ? body?.value : question?.value) ?? "";
}

export function findGroupHeader(
  groupHeaders: ITestGroupHeader[] | undefined,
  testId: number | undefined,
): ResolvedLocalizedContent | undefined {
  return groupHeaders?.find((header) => header.testId === testId)?.groupHeaderText;
}
